import { useCallback } from 'react';

import { useAuthApi } from '~domains/auth/api';

import { ampli } from '~shared/analytics';
import { growthBookInstance } from '~shared/growthbook';

import { findOrCreateWuid } from '@breeze/web-lib-wuid';
import { useRevokeSession } from '@breezeventures/web-ph-client-auth/api';
import { logoutAtom } from '@breezeventures/web-ph-client-auth/model';
import { useQueryClient } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';

export const useAuthService = () => {
  const authApi = useAuthApi();
  const clearAuthState = useSetAtom(logoutAtom);
  const queryClient = useQueryClient();
  const revokeSession = useRevokeSession({ authApi });

  const clearSession = useCallback(() => {
    queryClient.clear();
    clearAuthState();
    growthBookInstance.setAttributes({ id: findOrCreateWuid() });
  }, [queryClient, clearAuthState]);

  const logout = useCallback(async () => {
    ampli.client.track('mp_logout_click');
    await revokeSession.mutateAsync();
    clearSession();
  }, [revokeSession, clearSession]);

  return {
    logout,
    clearSession,
  };
};
